import { multiLan } from '@/assets/lan'

function checkStoragePermission() {
    try{
        window.localStorage;
    } catch(e) {
        const html = `<div style="padding:20px;"><h2>${multiLan('storage_permission_title')}</h2>${multiLan('storage_permission_steps')}</div>`
        document.body.innerHTML = html
    }
}

export {checkStoragePermission}